import { Box, Button } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

export default function AddButton({ link }) {
  return (
    <Box className="col-lg-2 col-md-12 text-center">
      <Link to={link}>
        <Button className="ButtomSearch" variant='contained'>+ เพิ่มรายการ</Button>
      </Link>
    </Box >
  )
}
